import { post2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const useSchedulePrintMutation = () => {
  const { t } = useTranslation();
  const branch = useBranchId();

  const mutation = useMutation({
    onSuccess: () => {
      toast.success(t("success.create"));
    },
    mutationFn: ({ ...body }: { start_date_and_time: string; end_date_and_time: string }) =>
      post2(`/internal/secure/pos/v2/personnel/print/receipt/${branch}`, body)
  });
  return mutation;
};

export default useSchedulePrintMutation;
